import { FC } from 'react'
import { useTranslation } from 'next-i18next'
import styles from './index.module.scss'
import { PrimaryHeading } from '../../atoms/PrimaryHeading'
import { CurrencyUnit, IMarketBase, IRoundBase } from '../../../types'
import { getFormattedAmount } from '../../../utils'

type Props = {
  investmentTargetMarkets: IMarketBase[]
  investmentTargetRounds: IRoundBase[]
  minInvestmentAmount: number
  maxInvestmentAmount: number
  currencyUnit: CurrencyUnit
}

export const ProfileInvestmentPolicy: FC<Props> = ({
  investmentTargetMarkets,
  investmentTargetRounds,
  minInvestmentAmount,
  maxInvestmentAmount,
  currencyUnit,
}) => {
  const { t } = useTranslation(['companies-users-[id]'])
  return (
    <div className={styles.container}>
      <div className={styles.heading}>
        <PrimaryHeading backgroundText='POLICY' htmlTagType='h2'>
          {t('投資方針')}
        </PrimaryHeading>
      </div>
      <div className={styles.contentList}>
        {investmentTargetMarkets.length > 0 && (
          <div className={styles.content}>
            <div className={styles.content__title}>{t('投資対象領域')}</div>
            <div className={styles.content__text}>
              {investmentTargetMarkets.map((market) => {
                return (
                  <span key={market.slug} className={styles.content__word}>
                    {' '}
                    {t(market.name)}
                  </span>
                )
              })}
            </div>
          </div>
        )}
        {investmentTargetRounds.length > 0 && (
          <div className={styles.content}>
            <div className={styles.content__title}>{t('投資対象ラウンド')}</div>
            <div className={styles.content__text}>
              {investmentTargetRounds.map((round) => {
                return (
                  <span key={round.slug} className={styles.content__word}>
                    {' '}
                    {t(round.name)}
                  </span>
                )
              })}
            </div>
          </div>
        )}
        {(minInvestmentAmount > 0 || maxInvestmentAmount > 0) && (
          <div className={styles.content}>
            <div className={styles.content__title}>{t('投資サイズ')}</div>
            <div className={styles.content__text}>
              <>
                {getFormattedAmount(minInvestmentAmount, currencyUnit)} ~{' '}
                {getFormattedAmount(maxInvestmentAmount, currencyUnit)}
              </>
            </div>
          </div>
        )}
      </div>
    </div>
  )
}
